/**
 * RSA加密
 * @author  OUYANGXIAOCHONG
 * @param {String|Object} v 所需加密的信息
 * @return {String}  encrypted   加密之后的信息
 */
import config from '../config'
import {JSEncrypt} from 'jsencrypt';

let publicKey=''
switch (config.ENV) {
    case '-test':
        publicKey='MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDhpJTeVWB2e5qjJ44N6LDONb+T0T5yZEwcb/mx3xxSOrMYj4UlalJJxQjecQd0hsXmbSXSHyXkVKyAXzhlOlI1rk8H6kWyU1dEst+CkGaHUyRpF2fkGXs3cAuiz/t2G1g8zfSGVWGaU3jZIYd5n89myL4hLJ5L3zggXO4FDgrO9wIDAQAB'
        break
    case '-uat':
        publicKey='MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCwqEycC4VPfioYwBmlx91er4mVKq+AcgDIiyDACumkTJ7LQk79ap0pO/cHhw4XlQHIfGP/B/7wUdirBxK7RbKx20a807JIQSXzEqdNFNhMvdIYss5c2Cu7KNCQ8luksr/b/Hp2UY3ov9OBScESWZ8DkEtHlQ9iaw1dtAWrwOCvTQIDAQAB'
        break
    case '':
        publicKey='MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDpmhiy1yLD0pKIXtgrzkFtQbWCwzulyKlzj2LM+7wYcFSDnR25JoFYTUm3Ozg0Jqd+ShFUn822A+aU3LLMHz+MDc+9EcVLRYnN2CW5WDL2spU6WlxkbNVUMUwShpOgdag4Nbo0VqFyqt/yrvN9p0irY7VfJFWV098wTQgBlX5d3QIDAQAB'
        break
}
// 使用openssl生成的公钥信息
const PUBLIC_KEY = publicKey;

const Rsa = (v) => {
    let key = new JSEncrypt();
    let text = v;
    key.setPublicKey(PUBLIC_KEY);
    let encrypted = key.encrypt(text);
    return encrypted;
};

export default Rsa



// WEBPACK FOOTER //
// ./src/utils/rsa.js